import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const listAllShiftTemplateService = async () => {
  try {
    return await http.get<any>(`/v1/shift-templates`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('getShiftTemplatesAllService error: ', error);
  }
};

export const getAllShiftTemplatesByPaginateService = async (
  page: number,
  take: number = 10,
  search: string = '',
  status: number = 1
) => {
  try {
    const query = search ? `&search=${search}` : '';
    return await http.get<any>(
      `/v1/shift-templates?page=${page}&take=${take}&status=${status}${query}`
    );
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAllShiftTemplatesByPaginateService error: ', error);
  }
};

export const getShiftTemplateByIdService = async (id: string) => {
  try {
    return await http.get<any>(`/v1/shift-templates/${id}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getShiftTemplateByIdService error: ', error);
  }
};

export const createShiftTemplateService = async (data: any, setPercentage?: any) => {
  try {
    return await http.post<any>(`/v1/shift-templates`, data, setPercentage);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('createShiftTemplateService error: ', error);
  }
};

export const updateShiftTemplateService = async (id: string, data: any) => {
  try {
    return await http.put<any>(`/v1/shift-templates/${id}`, data);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('updateShiftTemplateService error: ', error);
  }
};

export const deleteShiftTemplateService = async (
  id: string,
  search: string = '',
  page: number = 1,
  status: number = 1
) => {
  try {
    const query = search ? `&search=${search}` : '';
    return await http.delete<any>(
      `/v1/shift-templates/${id}?page=${page}&status=${status}${query}`
    );
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('desactiveShiftTemplateService error: ', error);
  }
};

export const restoreShiftTemplateService = async (
  id: string,
  search: string = '',
  page: number = 1,
  status: number = 1
) => {
  try {
    const query = search ? `&search=${search}` : '';
    return await http.patch<any>(
      `/v1/shift-templates/${id}/restore?page=${page}&status=${status}${query}`
    );
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('activeShiftTemplateService error: ', error);
  }
};
